import React, { useState, useContext } from "react";

// alphabetized
import Modal from "react-bootstrap/Modal";
import PrAgencyList from "../show/sidebar/pr_agency_list";
import SaveSpinnerButton from "./save_spinner_button";
import useCompanyUpdateApi from "../data/use_company_update_api";
import { CompanyContext } from "../data/company_context_management";

function PrAgenciesForm() {
  const context = useContext(CompanyContext);
  const { company, isUpdating, setOpenEditModal, setGeneralError } = context;
  const { updateCompany } = useCompanyUpdateApi({ ...context });
  const [showValue, setShowValue] = useState(company.page_config?.show_pr_agencies);

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const handleShowChange = (e) => {
    const newValue = e.target.checked;
    setShowValue(newValue);
  };

  const handleSubmit = (e) => {
    /* eslint-disable camelcase */
    e.preventDefault();

    const data = {
      show_pr_agencies: showValue,
    };

    const { show_pr_agencies } = data;

    const pageConfig = {
      ...company.page_config,
      show_pr_agencies,
    };

    updateCompany({ page_config: pageConfig });
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="show_pr_agencies">
              Show this section&nbsp;
              <small>(It&apos;s automatically generated)</small>
              <input
                type="checkbox"
                className="form-check-input"
                checked={showValue}
                onChange={handleShowChange}
                disabled={isUpdating}
                id="show_pr_agencies"
              />
            </label>
          </div>
        </form>
        <div className="w-50 mx-auto my-3" style={{ opacity: showValue ? "100%" : "30%", transition: "opacity 1s" }}>
          <PrAgencyList previewMode />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SaveSpinnerButton
          inactiveText="Save Changes"
          activeText="Saving..."
          isSaving={isUpdating}
          className="btn btn-primary"
          onClick={handleSubmit}
        />
        <button type="button" className="btn text-danger" onClick={closeModal} disabled={isUpdating}>
          Cancel
        </button>
      </Modal.Footer>
    </>
  );
}

export default PrAgenciesForm;
